import { render, staticRenderFns } from "./approveFile.vue?vue&type=template&id=d30cde26&scoped=true&"
import script from "./approveFile.vue?vue&type=script&lang=js&"
export * from "./approveFile.vue?vue&type=script&lang=js&"
import style0 from "./approveFile.vue?vue&type=style&index=0&id=d30cde26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30cde26",
  null
  
)

export default component.exports